module.exports = __webpack_public_path__ + "static/img/default.a5a5b39.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/default.png
// module id = 507
// module chunks = 1